


import { createSlice } from "@reduxjs/toolkit";

const errorHandlerSlice = createSlice({
    name: 'errorHandler',
    initialState: {},
    reducers: {
        addError: (state, action): any => {
            return {
                ...action.payload
            }
        },
        clearErrors: (): any => {
            return {}
        }
    },
});
export const { addError, clearErrors } = errorHandlerSlice.actions;
export default errorHandlerSlice.reducer;